import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CollectionsService } from '../../../collections/service/collections.service';
import { CartItem, SortedCartItems } from '../../interfaces/cart.interface';
import { RemoveCartItem } from '../../store/actions/cart.actions';
import { CartService } from '../../services/cart.service';
import { Subscription } from 'rxjs';
import i18next from 'i18next';
import { getCurrencySymbol } from '@angular/common';

@Component({
  selector: 'app-products-grid',
  templateUrl: './products-grid.component.html',
  styleUrls: ['./products-grid.component.scss'],
})
export class ProductsGridComponent implements OnInit {
  @Input() cartItems: CartItem[] | null = [];
  @Input() highlightSkus: number[] | null = [];
  @Input() transferedSkus: number[] | null = [];
  cartCollections: string[] = [];
  lang!: string;
  currencySymbol!: string;

  sortedCartItems: SortedCartItems[] = [];
  priceActive = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public collectionsService: CollectionsService,
    private store: Store<{ cart: CartItem }>,
    public cartService: CartService
  ) {}

  ngOnInit(): void {
    this.currencySymbol = getCurrencySymbol(
      this.collectionsService.currencyCode,
      'narrow'
    );

    this.lang = i18next.language;
    this.sortCartItems();
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);
  }

  ngOnChanges(): void {
    this.sortCartItems();
  }

  sortCartItems(): void {
    if (this.cartItems) {
      this.cartCollections = [
        ...new Set(this.cartItems.map((item) => item.collectionId)),
      ];
      this.sortedCartItems = [];
      for (let i = 0; i < this.cartCollections.length; i++) {
        const collectionId = this.cartCollections[i];
        this.sortedCartItems.push({
          collectionId,
          products: this.cartItems
            .filter((item) => item.collectionId === collectionId)
            .sort((a, b) => a.product.sku - b.product.sku),
        });
      }
    }
  }

  remove(cartItem: CartItem): void {
    this.store.dispatch(RemoveCartItem(cartItem));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
